import { makeStyles } from '@material-ui/core'
const useStyles = makeStyles({
  root: {
    backgroundColor: '#F2F2F2',
    boxShadow: 'rgb(238 238 238) 0px 0px 3px 0px',
    maxWidth: '500px',
    margin: '0px auto',
    minHeight: '90vh',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    boxSizing: 'border-box',
    justifyContent: 'center',
  },
  gridContainer: {
    width: 'auto',
    zIndex: 10,
  },
  paperImage: {
    width: '240px',
    height: '250px',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    backgroundPosition: 'center',
    backgroundColor: '#F2F2F2',
    backgroundImage: (props: any) => `url(${props.image})`,
  },
  goBackButton: {
    '&:hover': {
      backgroundColor: '#FFFFFF',
      color: '#2F4559',
    },
    backgroundColor: '#2F4559',
    color: '#FFFFFF',
  },
  goBackButtonRoot: {
    borderRadius: '15px',
    margin: '0rem 2rem',
  },
  gridContainerImage: {
    marginTop: 30,
  },
  textContainer: {
    margin: 20,
    color: '#7D7D7D',
  },
  subtitleText: {
    lineHeight: 1.5,
    marginTop: 5,
  },
})

export { useStyles }
